export const CREDIT_CARD_BANK_ACCOUNT_TYPE_ID = 10 // bank_account_type.name = 'Tarjeta de Crédito'

export const isCreditCardAccountType = cuentaTipoId =>
  Number(cuentaTipoId) === CREDIT_CARD_BANK_ACCOUNT_TYPE_ID

export const formatAccountBankName = (bankName, cuentaTipoId) => {
  if (!isCreditCardAccountType(cuentaTipoId)) return bankName
  const name = String(bankName || '').trim()
  if (!name || name.toUpperCase().startsWith('T.C')) return name || 'T.C'
  return `T.C ${name}`
}

export const formatAccountNumber = (numeroCuenta, cuentaTipoId) => {
  if (!numeroCuenta || !isCreditCardAccountType(cuentaTipoId)) return numeroCuenta
  const raw = String(numeroCuenta)
  const last4 = raw.replace(/^x{4}-/i, '').replace(/\D/g, '').slice(-4) || raw
  return `XXXX-${last4}`
}
